import { ApiClient } from './client';
import { CartService } from './services/cart';
import { ProductService } from './services/product';
import { UserService } from './services/user';
import { OrderService } from './services/order';
import { WishlistService } from './services/wishlist';
import { AuthService } from './services/auth';
import { CategoryService } from './services/category';
import { ChatService } from './services/chat';
import { AnalyticsService } from './services/analytics';
import { SearchService } from './services/search';
import { ContactService } from './services/contact';
import { StoreService } from './services/store';
import { ApiProviders } from './providers';
import { useAuth, useCart, useProducts, useProduct, useCategories } from './hooks.tsx';

/**
 * Clase principal que proporciona acceso a todos los servicios API
 */
class ApiManager {
  private static instance: ApiManager;
  
  public client: ApiClient;

  public products: ProductService;
  public cart: CartService;
  public users: UserService;
  public orders: OrderService;
  public wishlist: WishlistService;
  public auth: AuthService;
  public categories: CategoryService;
  public analytics: AnalyticsService;
  public chat: ChatService;
  public search: SearchService;
  public contact: ContactService;
  public stores: StoreService;

  private constructor(baseUrl: string = 'https://api.jarad.beeapp.es/api/v1') {
    // Crear el cliente API central
    this.client = new ApiClient(
      import.meta.env.DEV === true ? '/api/v1' : baseUrl
    );

    // Inicializar todos los servicios con el mismo cliente
    this.products = new ProductService(this.client);
    this.cart = new CartService(this.client);
    this.users = new UserService(this.client);
    this.orders = new OrderService(this.client);
    this.wishlist = new WishlistService(this.client);
    this.auth = new AuthService(this.client);
    this.categories = new CategoryService(this.client);
    this.analytics = new AnalyticsService(this.client);
    this.chat = new ChatService(this.client);
    this.search = new SearchService(this.client);
    this.contact = new ContactService(this.client);
    this.stores = new StoreService(this.client);
  }
  
  /**
   * Obtener instancia del ApiManager (patrón Singleton)
   */
  public static getInstance(baseUrl?: string): ApiManager {
    if (!ApiManager.instance) {
      ApiManager.instance = new ApiManager(baseUrl);
    }
    return ApiManager.instance;
  }
}

// Exportar instancia singleton
const apiManagerInstance = ApiManager.getInstance();
export default apiManagerInstance;

// Exportar proveedores de contexto y hooks
export {
  ApiProviders,
  useAuth,
  useCart,
  useProducts,
  useProduct,
  useCategories
}; 